// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__yh0Zv","error":"Textarea_error__288Un","readonly":"Textarea_readonly__7zUdZ","disabled":"Textarea_disabled__YasGo"};